import React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'

const Loader = ({ message }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <CircularProgress size={20} color="primary" />
      <Typography>{message ? message : 'Loading...'}</Typography>
    </Box>
  )
}

export default Loader
